import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Yachts from "./pages/Yachts";
import Services from "./pages/Services";
import Events from "./pages/Events";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import BlogInside from "./pages/BlogInside";
import LuxuryYachts from "./pages/LuxuryYachts";
import YachtDetails from "./pages/YachtDetails";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ScrollToTop from "./components/ScrollToTop";

const AppContent = () => {
  const location = useLocation();
  const hideNavbarRoutes = ["/"]; // Add routes where you want to hide the navbar

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-blueharbour-yacht-rentals" element={<About />} />
        <Route path="/yacht-rental-dubai" element={<Yachts />} />
        <Route path="/luxury-yachts" element={<LuxuryYachts />} />
        <Route path="/yacht-details/:id" element={<YachtDetails />} />
        <Route path="/yacht-rental-services-dubai" element={<Services />} />
        <Route path="/rental-yacht-events-dubai" element={<Events />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/blog/:url_title" element={<BlogInside />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-condition" element={<TermsAndConditions />} />
      </Routes>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
};

export default App;
